import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "dva";

/**
 * 将context取出转为props 的装饰器
 * 简化代码，传入上下文配置 contextTypes即可取出context
 *
 *
 */

@connect()
class HandleAlarm extends PureComponent {
    render() {
        const { children } = this.props;
        let handleAlarm = (data) => {
            data.visible = true;
            this.props.dispatch({ type: 'commonModel/changeAlarmInfoVisible', data })
        }
        let parm = { handleAlarm };
        let ret = React.cloneElement(children, { ...parm })
        return (
            <React.Fragment>
                {ret}
            </React.Fragment>
        )
    }
}

const context2Props = () => WrappedComponent => class extends PureComponent {
    render() {
        return <HandleAlarm><WrappedComponent {...this.props} /></HandleAlarm>
    }
}

export default context2Props;
export const handleAlarmContext2Props = () => context2Props()
